<div
  class="sp-min-height__full sp-width__full sp-position__relative">
  <app-plain-toolbar 
    [icon_button_class]="'sp-icon__button-accent'"
    [logo_src]="
    '../../../assets/img/logo/sp-logo-dark.svg'
    "></app-plain-toolbar>
  
  <div
    class="sp-page__with-toolbar sp-row sp-padding__top-x4 sp-padding__bottom-x4">
    <app-auth-new-password-form class="sp-margin__auto"></app-auth-new-password-form>
  </div>
</div>
